var map = {
	"./arrow.svg": "21e2",
	"./assignment.svg": "211e",
	"./bingcao-icon-gray.svg": "c638",
	"./bingcao-icon.svg": "56925",
	"./burger.svg": "ada2b",
	"./cards.svg": "3c00",
	"./check.svg": "7bae",
	"./extends.svg": "bc10",
	"./groupBuy.svg": "3cfb",
	"./phone.svg": "c3bb",
	"./set-up-1.svg": "a5f7",
	"./set-up-2.svg": "abd3",
	"./set-up-3.svg": "aa6b",
	"./set-up-4.svg": "eb52",
	"./set-up-background.svg": "64e9",
	"./tab-icon-art.svg": "3a67",
	"./tab-icon-child.svg": "88d7",
	"./tab-icon-dance.svg": "9ea1",
	"./tab-icon-sport.svg": "5bb1",
	"./tab-icon-yoga.svg": "9860",
	"./users.svg": "d956",
	"./wechat.svg": "95d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b422";